import { render, staticRenderFns } from "./app-type-tag.vue?vue&type=template&id=3cd7160c"
import script from "./app-type-tag.vue?vue&type=script&lang=js"
export * from "./app-type-tag.vue?vue&type=script&lang=js"
import style0 from "./app-type-tag.vue?vue&type=style&index=0&id=3cd7160c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports